import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminConcerns = () => (
  <CrudManager
    title="Health Concerns"
    subtitle="The concerns grid on the homepage — mapped to product tags."
    endpoint="/admin/concerns"
    idField="slug"
    useKeyInPath
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'slug', label: 'Slug' },
      { key: 'icon', label: 'Icon' },
    ]}
    initial={{ slug: '', name: '', description: '', icon: 'leaf' }}
    fields={[
      { key: 'slug', label: 'Slug', required: true, help: 'e.g. gut-health, sleep, stress — used in URLs.' },
      { key: 'name', label: 'Name', required: true },
      { key: 'description', label: 'Short description' },
      { key: 'icon', label: 'Icon', help: 'One of: sparkles, leaf, wind, flower, activity, droplet, heart, moon, bed, sun' },
      { key: 'color', label: 'Accent colour (hex)', placeholder: '#8A9A5B', help: 'Earthy accent used on the homepage concerns grid and product cards tagged with this concern.' },
    ]}
  />
);
export default AdminConcerns;
